module.exports = __webpack_public_path__ + "img/YO.56598507.png";